export default __webpack_public_path__ + "static/media/approve.f789c753.svg";